import React from 'react'
import styles from './pending.styles'
import injectSheet from 'react-jss'
import Spinner from 'pobble-components/dist/spinner'
import Container from '../components/container/container'

const Pending = ({ classes }) => (
  <Container className={classes.container}>
    <Spinner />
  </Container>
)

export default injectSheet(styles)(Pending)
